const EarlyCheckinIcon = props => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="#55B685"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13.5417 3.125C8.36457 3.125 4.16666 7.32292 4.16666 12.5H1.04166L5.09374 16.5521L5.16666 16.6979L9.37499 12.5H6.24999C6.24999 8.46875 9.51041 5.20833 13.5417 5.20833C17.5729 5.20833 20.8333 8.46875 20.8333 12.5C20.8333 16.5312 17.5729 19.7917 13.5417 19.7917C11.5312 19.7917 9.70832 18.9687 8.39582 17.6458L6.91666 19.125C8.61457 20.8229 10.9479 21.875 13.5417 21.875C18.7187 21.875 22.9167 17.6771 22.9167 12.5C22.9167 7.32292 18.7187 3.125 13.5417 3.125ZM12.5 8.33333V13.5417L16.9583 16.1875L17.7083 14.9271L14.0625 12.7604V8.33333H12.5Z" />
  </svg>
)

export default EarlyCheckinIcon
